import React, { createContext, useState, useContext } from "react";

const ApiContext = createContext();

export const ApiProvider = ({ children }) => {
  const [apiData, setApiData] = useState(null);

  const updateApiData = (data) => {
    setApiData(data);
  };

  return (
    <ApiContext.Provider value={{ apiData, updateApiData }}>
      {children}
    </ApiContext.Provider>
  );
};

export const useApi = () => useContext(ApiContext);
